import { Component, input } from '@angular/core';

@Component({
  selector: 'rid-lettermix-word',
  imports: [],
  templateUrl: './rid-lettermix-word.html',
})
export class RidLettermixWord {
  word = input.required<string[]>();
  appearance = input.required<'SPOILER' | 'CORRECT' | 'REVEAL'>();
}
